import React from 'react'
import { SeatCard } from '../SeatCard/SeatCard'
import { getSeatsData, InterknowlogyData, transformAreaData } from '../data'
import { ElectionTitle, StyledElectionTitleContainer } from '../components'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import { TransformedData } from '@west-australian-newspapers/election-api-types'

export interface SeatsWidgetProps {
    data: MaybeLoaded<TransformedData>
}

export const TheSeatsWidget = ({ data }: SeatsWidgetProps): JSX.Element => {
    // Loading State!
    if (!data.loaded) {
        return (
            <>
                {Array(5) // Render 5 skeletons while loading
                    .fill(0)
                    .map((_, index) => (
                        <SeatCard key={index} isLoading />
                    ))}
            </>
        )
    }

    // Transform the data into the shape we need for the widget
    const interknowlogyData = transformAreaData(
        data.result as InterknowlogyData,
    )
    const seatData = getSeatsData(interknowlogyData)

    return (
        <>
            <StyledElectionTitleContainer>
                <ElectionTitle>The Seats</ElectionTitle>
            </StyledElectionTitleContainer>
            {seatData.slice(0, 10).map((seat) => (
                <SeatCard key={seat.seatId} seat={seat} />
            ))}
        </>
    )
}
